/**
 * 检查字符串是否只包含字母和数字
 */
export function isAlphanumeric(str: string) {
  return /^[a-zA-Z0-9]+$/.test(str);
}
